module.exports = __webpack_public_path__ + "img/348.04043508.png";